import {
  Dumbbell, Coffee, Waves, Baby, PawPrint, HeartPulse, Gamepad2, Trophy, Wine, Flag, Sun,
} from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../constants/site";

const ICON_AMENITIES = [
  { icon: Wine, label: "Rooftop Lounge" },
  { icon: Coffee, label: "Café" },
  { icon: Dumbbell, label: "Fitness Centre" },
  { icon: Waves, label: "Steam Room" },
  { icon: Trophy, label: "Pickleball Court" },
  { icon: Flag, label: "Turf" },
  { icon: Gamepad2, label: "Indoor Games Room" },
  { icon: Baby, label: "Crèche" },
  { icon: PawPrint, label: "Pet Crèche" },
  { icon: HeartPulse, label: "Medical Room" },
  { icon: Sun, label: "Red Light Therapy Room" },
];

export default function Amenities() {
  return (
    <section id="amenities" data-testid="amenities-section" className="py-24 md:py-32 border-t border-border">
      <div className="max-w-screen-2xl mx-auto px-6">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.35em] text-primary mb-5">11+ Lifestyle Amenities</p>
          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl leading-tight mb-14">
            Service, at <span className="italic text-primary">hotel standard</span>
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[190px] gap-4">
          <Reveal className="md:col-span-2 md:row-span-2" >
            <div data-testid="amenity-lobby" className="group relative h-full overflow-hidden border border-border">
              <img src={IMAGES.meetingRoom} alt="Grand arrival lobby" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <p className="absolute bottom-6 left-6 font-display text-2xl md:text-3xl text-white">Grand Double-Height Lobby</p>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="md:col-span-2">
            <div data-testid="amenity-conference" className="group relative h-full overflow-hidden border border-border">
              <img src={IMAGES.conference} alt="Conference suites" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              <p className="absolute bottom-5 left-6 font-display text-xl md:text-2xl text-white">Business Lounge & Conference Suites</p>
            </div>
          </Reveal>
          <Reveal delay={0.14} className="md:col-span-2">
            <div data-testid="amenity-waterfront" className="group relative h-full overflow-hidden border border-border">
              <img src={IMAGES.skyReflection} alt="Waterfront promenade" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              <p className="absolute bottom-5 left-6 font-display text-xl md:text-2xl text-white">Waterfront Promenade & Greens</p>
            </div>
          </Reveal>
          {ICON_AMENITIES.map(({ icon: Icon, label }, i) => (
            <Reveal key={label} delay={0.08 + (i % 4) * 0.06}>
              <div
                data-testid={`amenity-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group h-full border border-border p-6 flex flex-col justify-between hover:border-primary/60 hover:bg-primary/5 transition-colors"
              >
                <Icon size={22} className="text-primary group-hover:-translate-y-1 transition-transform duration-300" strokeWidth={1.5} />
                <p className="text-sm text-foreground/90 leading-snug">{label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
